import * as types from '@/store/types'
import {REQUEST_STATUS} from '@/store/utils/request-status'
import {fetchComments} from '@/api/comment'

const state = {
  items: {},
  status: REQUEST_STATUS.NONE
}

const actions = {
  async fetchComments ({commit}, imageKey) {
    commit(types.COMMENT__FETCH_INIT)
    try {
      const {data} = await fetchComments(imageKey)
      commit(types.COMMENT__FETCH_SUCCESS, data)
    } catch (err) {
      const errors = err.response ? err.response.data : err
      commit(types.COMMENT__FETCH_FAILURE, errors)
    }
  }
}

const mutations = {
  [types.COMMENT__FETCH_INIT] (state) {
    state.status = REQUEST_STATUS.GET
  },
  [types.COMMENT__FETCH_SUCCESS] (state, comments) {
    //state.items = comments.reduce((acc, x) => ({...acc, [x['_id']]: x}), state.items)
    state.items = comments

    // example
    // state.items = [
    //   {"text": "comment1", 'created_at': '1576091868821'},
    //   {"text": "comment2", 'created_at': '1576091868811'},
    //   {"text": "comment3", 'created_at': '1576091868831'},
    //   {"text": "comment4", 'created_at': '1576091868841'}]
    state.status = REQUEST_STATUS.NONE
  },
  [types.COMMENT__FETCH_FAILURE] (state, errors) {
    state.status = REQUEST_STATUS.NONE
    console.error(errors)
  }
}

export default {
  state,
  actions,
  mutations
}
